import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart } from "../../redux/feature/cartReducer";
import { useState } from "react";
import "../navbar/navbar.css";
import { useEffect } from "react";

const ModalItem = ({
  id,
  image,
  title,
  price,
  quantity,
  totalPrice,
  isOpen,
  setIsOpen,
}) => {
  const totalQuantity = useSelector((state) => state.cart.totalQuantity);

  const dispatch = useDispatch();
  const [animationClass, setAnimationClass] = useState("");
  const [animationItemClass, setAnimationItemClass] = useState(
    "animate__animated animate__fadeInRight"
  );
  const [show, setShow] = useState(false);
  const [quantityLoading, setQuantityLoading] = useState(false);

  const incCartitems = () => {
    setQuantityLoading(true);
    setTimeout(() => {
      setQuantityLoading(false);
      dispatch(addToCart({ id, title, price }));
    }, 300);
  };

  const decCartitems = () => {
    setQuantityLoading(true);
    if (quantity === 1) {
      setAnimationClass("animate__animated animate__fadeInRight");
      setShow(true);
      setQuantityLoading(false);
    } else {
      setTimeout(() => {
        setQuantityLoading(false);
        dispatch(removeFromCart(id));
      }, 300);
    }
  };

  const handleYesClick = () => {
    if (totalQuantity === 1) {
      setTimeout(() => {
        dispatch(removeFromCart(id));
        setAnimationClass("animate__animated animate__fadeOutLeft");
        setIsOpen(false);
      }, 500);
      setAnimationItemClass("animate__animated animate__fadeOutLeft");
    } else {
      setTimeout(() => {
        dispatch(removeFromCart(id));
        setAnimationClass("animate__animated animate__fadeOutLeft");
      }, 500);
      setAnimationItemClass("animate__animated animate__fadeOutLeft");
    }

    if (window.location.pathname === "/payment" && totalQuantity === 1) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 500);
    }
  };

  const handleNoClick = () => {
    setAnimationClass("animate__animated animate__fadeOutLeft");
    setTimeout(() => {
      setShow(false);
    }, 500);
  };

  //! When the modal is closed -
  //! also close the warning messages in the Modal.
  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        setShow(false);
      }, 300);
    }
  }, [isOpen]);

  return (
    <>
      <div className={`modal-flex ${animationItemClass}`}>
        {show && (
          <div className={`product-boot-modal ${animationClass}`}>
            <h6 className="text-center">Delete Product?</h6>
            <div className="modal-item-yes-no-buttons">
              <button onClick={handleYesClick}>Yes</button>
              <button onClick={handleNoClick}>No</button>
            </div>
          </div>
        )}
        <img className="modal-img" src={image} alt="item" />

        <div className="modal-btn m-2">
          {quantity === 1 && (
            <button title="Delete" onClick={decCartitems} className="btn-minus">
              <i className="quantity-one fas fa-solid fa-trash-can animate__animated animate__fadeIn"></i>
            </button>
          )}
          {quantity > 1 && (
            <button onClick={decCartitems} className="btn-minus fw-bold">
              -
            </button>
          )}
          {quantityLoading ? (
            <span className="quantity-loader-parent">
              <span className="quantity-loaderGif"></span>
            </span>
          ) : (
            <span className="quantity animate__animated animate__fadeIn">
              {quantity}
            </span>
          )}
          <button onClick={incCartitems} className="btn-plus fw-bold">
            +
          </button>
        </div>
        <div className="item-price">${totalPrice?.toFixed(2)}</div>
      </div>
    </>
  );
};

export default ModalItem;
